export const nf = (v, d = 1) =>
  v === null || v === undefined || v === "" || Number.isNaN(v)
    ? "—"
    : Number(v).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });

export const pf = (v) =>
  v === null || v === undefined || Number.isNaN(v) ? "—" : Number(v).toFixed(3);

export const pct = (v) =>
  v === null || v === undefined || Number.isNaN(v) ? "—" : `${(Number(v) * 100).toFixed(1)}%`;

export const money = (v) =>
  v === null || v === undefined || Number.isNaN(v)
    ? "—"
    : `${v < 0 ? "-" : ""}$${Math.abs(Number(v)).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const signed = (v, d = 1) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const s = nf(Math.abs(v), d);
  return v < 0 ? `(${s})` : v > 0 ? `+${s}` : s;
};
